import changeCities from "../modules/Utils/changeCities";
changeCities();

/*
        SUMMARY
            0 - Const / Variables
            1 - Functions
            2 - Event Listeners
            3 - Initialize
*/

/*---------------------/ 0 - Const - Variables /-------------------*/
let heroSwiper = null;
let heroTimeline = null;
let produtosSwiper = null;

/*---------------------/ 1 - Functions /-------------------*/
// Initialize Hero Swiper
function initHeroSwiper() {
    if (document.querySelector('.hero-swiper')) {
        heroSwiper = new Swiper('.hero-swiper', {
            // Basic Options
            loop: true,
            speed: 1000,
            autoplay: {
                delay: 10000,
                disableOnInteraction: false,
            },

            // Effects
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },

            // Pagination
            pagination: {
                el: '.swiper-pagination-container',
                clickable: true,
                type: 'bullets',
            },

            // Keyboard Control
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },

            // Accessibility
            a11y: {
                enabled: true,
                prevSlideMessage: 'Slide anterior',
                nextSlideMessage: 'Próximo slide',
                firstSlideMessage: 'Este é o primeiro slide',
                lastSlideMessage: 'Este é o último slide',
            },

            // Breakpoints
            breakpoints: {
                320: {
                    autoplay: {
                        delay: 4000,
                    },
                },
                768: {
                    autoplay: {
                        delay: 5000,
                    },
                },
                1024: {
                    autoplay: {
                        delay: 6000,
                    },
                }
            },

            // Callbacks
            on: {
                init: function () {
                    // Add loaded class to first slide
                    this.slides[this.activeIndex].classList.add('slide-loaded');
                    // Animate first slide
                    animateHeroSlide(this.slides[this.activeIndex]);
                },
                slideChange: function () {
                    // Remove loaded class from all slides
                    this.slides.forEach(slide => {
                        slide.classList.remove('slide-loaded');
                    });

                    // Add loaded class to current slide
                    this.slides[this.activeIndex].classList.add('slide-loaded');
                },
                slideChangeTransitionStart: function () {
                    // Reset previous slide animations
                    resetHeroAnimations();
                },
                slideChangeTransitionEnd: function () {
                    // Animate current slide
                    animateHeroSlide(this.slides[this.activeIndex]);
                }
            }
        });
    }
}

// Animate Hero Slide Elements with GSAP
function animateHeroSlide(slide) {
    if (!slide) return;

    // Kill any existing timeline
    if (heroTimeline) {
        heroTimeline.kill();
    }

    // Create new timeline
    heroTimeline = gsap.timeline();

    // Get elements from current slide
    const subtitle = slide.querySelector('.hero-subtitle');
    const title = slide.querySelector('.hero-title');
    const description = slide.querySelector('.hero-description');
    const actions = slide.querySelector('.hero-actions');

    // Set initial states
    gsap.set([subtitle, title, description, actions], {
        opacity: 0,
        y: 30
    });

    // Create staggered animation timeline
    heroTimeline
        .to(subtitle, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: "power2.out"
        })
        .to(title, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: "power2.out"
        }, "-=0.6")
        .to(description, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: "power2.out"
        }, "-=0.6")
        .to(actions, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: "power2.out"
        }, "-=0.6");
}

// Reset Hero Animations
function resetHeroAnimations() {
    if (heroTimeline) {
        heroTimeline.kill();
    }

    // Reset all slides elements
    const allSlides = document.querySelectorAll('.swiper-slide');
    allSlides.forEach(slide => {
        const elements = slide.querySelectorAll('.hero-subtitle, .hero-title, .hero-description, .hero-actions');
        gsap.set(elements, {
            opacity: 0,
            y: 30
        });
    });
}

// Handle scroll indicator click
function handleScrollIndicator() {
    const scrollArrows = document.querySelectorAll('.scroll-arrow');

    scrollArrows.forEach(arrow => {
        arrow.addEventListener('click', function() {
            // Find the produtos section (next section after hero)
            const produtosSection = document.querySelector('.produtos-section');
            console.log('Produtos section:', produtosSection);

            if (produtosSection) {
                // Smooth scroll to produtos section
                produtosSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });
}

// Handle pause/resume on hover
function handleHoverPause() {
    const heroSection = document.querySelector('.hero-section');

    if (heroSection && heroSwiper) {
        heroSection.addEventListener('mouseenter', function() {
            heroSwiper.autoplay.stop();
        });

        heroSection.addEventListener('mouseleave', function() {
            heroSwiper.autoplay.start();
        });
    }
}

// Handle visibility change (pause when tab is not active)
function handleVisibilityChange() {
    if (heroSwiper) {
        document.addEventListener('visibilitychange', function() {
            if (document.hidden) {
                heroSwiper.autoplay.stop();
                if (heroTimeline) {
                    heroTimeline.pause();
                }
            } else {
                heroSwiper.autoplay.start();
                if (heroTimeline) {
                    heroTimeline.resume();
                }
            }
        });
    }
}

// Preload images
function preloadHeroImages() {
    const heroImages = document.querySelectorAll('.hero-image');

    heroImages.forEach(img => {
        const imageUrl = img.src;
        const preloadImg = new Image();
        preloadImg.src = imageUrl;
    });
}

// Initialize Produtos Swiper
function initProdutosSwiper() {
    if (document.querySelector('.produtos-swiper')) {
        produtosSwiper = new Swiper('.produtos-swiper', {
                        // Basic Options
            loop: true,
            speed: 800,
            slidesPerView: 'auto',
            spaceBetween: 20,

            // Responsive breakpoints
            breakpoints: {
                // When window width is >= 768px
                768: {
                    spaceBetween: 20,
                },
                // When window width is >= 1024px
                1024: {
                    spaceBetween: 20,
                },
                // When window width is >= 1280px
                1280: {
                    spaceBetween: 20,
                }
            },

            // Navigation arrows
            navigation: {
                nextEl: '.produtos-nav-next',
                prevEl: '.produtos-nav-prev',
            },

            // Keyboard Control
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },

            // Accessibility
            a11y: {
                enabled: true,
                prevSlideMessage: 'Produto anterior',
                nextSlideMessage: 'Próximo produto',
            },

            // Callbacks
            on: {
                init: function () {
                    // Initial setup
                    this.update();
                },
                slideChange: function () {
                    // Handle slide change if needed
                }
            }
        });
    }
}

// Initialize GSAP ScrollTrigger (if needed for other elements)
function initScrollTrigger() {
    if (typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
    }
}

/*---------------------/ 2 - Event Listeners /-------------------*/
// DOM Content Loaded
document.addEventListener('DOMContentLoaded', function() {
    // Initialize GSAP plugins
    initScrollTrigger();

    // Initialize components
    initHeroSwiper();
    initProdutosSwiper();
    handleScrollIndicator();
    handleHoverPause();
    handleVisibilityChange();
    preloadHeroImages();
});

// Window Load
window.addEventListener('load', function() {
    // Additional initialization after all resources are loaded
    if (heroSwiper) {
        heroSwiper.update();
    }
    if (produtosSwiper) {
        produtosSwiper.update();
    }
});

// Window Resize
window.addEventListener('resize', function() {
    if (heroSwiper) {
        heroSwiper.update();
    }
    if (produtosSwiper) {
        produtosSwiper.update();
    }
});

// Handle page visibility for better performance
window.addEventListener('beforeunload', function() {
    if (heroTimeline) {
        heroTimeline.kill();
    }
});

/*---------------------/ 3 - Initialize /-------------------*/
// Export for potential external use
window.HeroSlider = {
    swiper: heroSwiper,
    timeline: heroTimeline,
    init: initHeroSwiper,
    animate: animateHeroSlide,
    reset: resetHeroAnimations,
    destroy: function() {
        if (heroSwiper) {
            heroSwiper.destroy(true, true);
            heroSwiper = null;
        }
        if (heroTimeline) {
            heroTimeline.kill();
            heroTimeline = null;
        }
    }
};

// Export for produtos slider
window.ProdutosSlider = {
    swiper: produtosSwiper,
    init: initProdutosSwiper,
    destroy: function() {
        if (produtosSwiper) {
            produtosSwiper.destroy(true, true);
            produtosSwiper = null;
        }
    }
};

